export const onlyAlphanumericRegex = /^[a-zA-Z0-9ñÑ\s]+$/;
export const NITValidationRegex = /^[6789]\d{8}$/;
